// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-document-language-selector .lang-menu-btn {
  padding: 0;
  margin-right: 16px;
}
.fi-document-language-selector .lang-menu-btn .mdc-button__ripple {
  display: none;
}
.fi-document-language-selector .lang-menu-btn .mdc-button__label > .fa {
  line-height: 36px;
  margin-left: 10px;
}
.fi-document-language-selector .lang-simple-text {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./Source/app/document/layout/document-language-selector/document-language-selector.component.scss"],"names":[],"mappings":"AACE;EACE,UAAA;EACA,kBAAA;AAAJ;AACI;EACE,aAAA;AACN;AAEM;EACE,iBAAA;EACA,iBAAA;AAAR;AAIE;EACE,iBAAA;AAFJ","sourcesContent":[".fi-document-language-selector {\r\n  .lang-menu-btn {\r\n    padding: 0;\r\n    margin-right: 16px;\r\n    .mdc-button__ripple {\r\n      display: none;\r\n    }\r\n    .mdc-button__label {\r\n      > .fa {\r\n        line-height: 36px;\r\n        margin-left: 10px;\r\n      }\r\n    }\r\n  }\r\n  .lang-simple-text {\r\n    margin-right: 8px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
